/** Независимая проверка обязательства в браузере: SHA-256(salt + ":" + payload) == hash. */
export async function verifyCommitment(hash: string, salt: string, payload: string): Promise<boolean> {
  const data = new TextEncoder().encode(`${salt}:${payload}`);
  const digest = await crypto.subtle.digest('SHA-256', data);
  const hex = [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
  return hex === hash;
}
